import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClient } from '@angular/common/http';

import { ErrorHandlerInterceptor } from './interceptor/error-handler.interceptor';
import { CacheInterceptor } from './interceptor/cache.interceptor';
import { AuthInterceptor } from './interceptor/auth.interceptor';

import { AuthenticationService } from './service/authentication.service';
import { AuthenticationGuard } from './guard/authentication.guard';
import { HttpCacheService } from './service/http-cache.service';

@NgModule({
  declarations: [],
  imports: [CommonModule, HttpClientModule],
  providers: [
    HttpCacheService,
    AuthenticationService,
    AuthenticationGuard,
    ErrorHandlerInterceptor,
    CacheInterceptor,
    {
      provide: HttpClient
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ]
})
export class CoreModule {}
